import Base from './Base';

/**
 * 单例类的基类
 */
let _singetons = new Map;
export default class Singleton extends Base {
    /**
     * 构造函数
     * @return {undefined}
     */
    constructor(options) {
        super(options);
    }

    /**
     * 销毁单例实例对象
     * @return {undefined}
     */
    destroy() {
        _singetons.delete(this.constructor);
    }

    /**
     * 获取单例对象的实例
     * @param  {...all} rest 参数
     * @return {class}  单例对象的实例
     */
    static getInstance(...rest) {
        let instance = null;
        if (!_singetons.has(this)) {
            instance = new this(...rest);
            _singetons.set(this, instance);
        }
        return _singetons.get(this);
    }

    /**
     * 销毁所有单例类实例
     * @return {undefined}
     */
    static destroyAll() {
        if (this !== Singleton) {
            throw new Error('只有单例基类Singleton可以执行desctroyAll方法。');
        }

        _singetons.forEach(item => {
            item.destroy();
        });

        // 防止子类的destroy方法未调用父类的destroy
        _singetons.clear();
    }
}
